import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  method: "GET",
  action: "/events/",
  class: "search-form",
  "x-data": "{ searchModal: '', selectedCategories: [], selectedLocations: [] }",
  id: "search-form"
}
const _hoisted_2 = {
  key: 0,
  class: "modal modal--filters"
}
const _hoisted_3 = { class: "modal__content" }
const _hoisted_4 = { class: "modal__inner tw-py-6" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "modal__footer" }
const _hoisted_7 = {
  key: 1,
  class: "modal modal--filters"
}
const _hoisted_8 = { class: "modal__content" }
const _hoisted_9 = { class: "modal__inner tw-py-6" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "modal__footer" }
const _hoisted_12 = { class: "container mx-auto" }
const _hoisted_13 = { class: "tw-flex tw-flex-wrap md:tw-flex-nowrap tw-justify-center -tw-mx-3" }
const _hoisted_14 = { class: "tw-mt-4 md:tw-mt-0 tw-w-full md:tw-w-2/12 tw-px-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    ($data.showModal == 'categories')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal__background" }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              href: "#",
              class: "modal__close",
              onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($data.showModal = ''), ["prevent"]))
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "fa-light fa-xmark" }, null, -1 /* CACHED */)
            ]))]),
            _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "modal__title tw-text-xl tw-text-brand-blue tw-font-medium tw-tracking-wide" }, "Categories", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.categories, (category) => {
                return (_openBlock(), _createElementBlock("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: category.slug,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.selectedCategories) = $event))
                  }, null, 8 /* PROPS */, _hoisted_5), [
                    [_vModelCheckbox, $data.selectedCategories]
                  ]),
                  _createTextVNode(" " + _toDisplayString(category.name), 1 /* TEXT */)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn--primary",
                onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($data.showModal = ''), ["prevent"]))
              }, "Select")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($data.showModal == 'locations')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "modal__background" }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              href: "#",
              class: "modal__close",
              onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($data.showModal = ''), ["prevent"]))
            }, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("i", { class: "fa-light fa-xmark" }, null, -1 /* CACHED */)
            ]))]),
            _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "modal__title tw-text-xl tw-text-brand-blue tw-font-medium tw-tracking-wide" }, "Locations", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.locations, (location) => {
                return (_openBlock(), _createElementBlock("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: location.slug,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.selectedLocations) = $event))
                  }, null, 8 /* PROPS */, _hoisted_10), [
                    [_vModelCheckbox, $data.selectedLocations]
                  ]),
                  _createTextVNode(" " + _toDisplayString(location.name), 1 /* TEXT */)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn--primary",
                onClick: _cache[5] || (_cache[5] = _withModifiers($event => ($data.showModal = ''), ["prevent"]))
              }, "Select")
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass(($props.hideLocations ? 'tw-mt-4 md:tw-mt-0 tw-w-full md:tw-w-5/12 tw-px-3' : 'tw-mt-4 md:tw-mt-0 tw-w-full md:tw-w-1/3 tw-px-3'))
        }, [
          _cache[14] || (_cache[14] = _createElementVNode("label", null, "Filter by dates", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "option-selector",
            id: "datepicker",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.dates) = $event))
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $data.dates]
          ])
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_14, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "tw-hidden md:tw-block" }, " ", -1 /* CACHED */)),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => ($options.runFilters && $options.runFilters(...args)), ["prevent"])),
            class: "btn btn--primary"
          }, "Find Events")
        ])
      ])
    ])
  ]))
}